import cx from 'classnames';
import { Fragment, useState } from 'react';
import { Expansions, Patches } from '../../../../../../shared/common/enums';
import { withSiteMeta } from '../../../../../../shared/frontend/HOCS/withSiteMeta';
import TakeoverStatus from '../../../../../../shared/frontend/components/ads/takeoverStatus';
import { VideoDockedComponent } from '../../../../../../shared/frontend/components/ads/videoComponent';
import { Link, TrackedLink } from '../../../../../../shared/frontend/components/link';
import { Media } from '../../../../../../shared/frontend/components/presentational/media';
import { asset } from '../../../../../../shared/frontend/services/assetResolverService';
import {
  LARGE_SIZE,
  SMALL_SIZE,
  StatelessInteractiveStreamPreview,
  X_LARGE_SIZE,
  X_SMALL_SIZE
} from './streamMastheads/shared';
import { ArkheronMastheadFeature, isArkheronMastheadActive } from './streamMastheads/arkheronMasthead2026';
import { TierMn1WorldFirst, isTierMn1RWFActive } from './streamMastheads/rwfTierMn1';
import { isAwcTWWBracketActive, AWCTWWBlizzardFeature } from './streamMastheads/awcTWW';
import { isMDIBracketActive, MDIBlizzardFeature } from './streamMastheads/mdiEventBracket';

function DockedStreamView(props: any) {
  const secondaryStreamers = [...props.streamers];

  const [activeStream, setActiveStream] = useState(0);

  const [mainStreamer] = secondaryStreamers.splice(activeStream, 1);

  const activeStreamSize = props.isSmallScreen ? SMALL_SIZE : LARGE_SIZE;

  const isMainShowingTitle = (props.isSmallScreen ? false : true) || mainStreamer.stream.is_featured_stream;

  return (
    <div
      className={cx(
        props.className,
        'rio-fuzzy-border rio-fuzzy-border--large',
        'slds-p-around--x-small slds-text-align--center slds-grid slds-grid--vertical-align-center slds-align--absolute-center'
      )}
      style={{
        backgroundImage: `url(${asset(
          `/images/dungeons/expansion${Expansions.Current}/all-dungeons-patch-${Patches.Current}.jpg`,
          {
            width: 600,
            quality: 90
          }
        )})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <StatelessInteractiveStreamPreview
        type="twitch"
        className="stream--larger streamer-threeway-offset slds-col slds-shrink-none"
        thumbnailUrl={mainStreamer.stream.thumbnail_url}
        width={activeStreamSize.width}
        height={activeStreamSize.height}
        thumbnailWidth={activeStreamSize.width}
        thumbnailHeight={activeStreamSize.height}
        viewerCount={mainStreamer.stream.viewer_count}
        streamIdentifier={mainStreamer.stream.name}
        isFeatured={mainStreamer.stream.is_featured_stream}
        featuredTitle={mainStreamer.stream.title}
        streamerTitle={
          <span>
            <TrackedLink
              href={`https://twitch.tv/${mainStreamer.stream.name}`}
              className="rio-realm-link rio-text--shadow"
              target="_blank"
              as="twitch:preview"
            >
              {mainStreamer.stream.name}
            </TrackedLink>
            {mainStreamer.guild && (
              <>
                {' '}
                of{' '}
                <Link className="rio-realm-link" to={mainStreamer.guild.path}>
                  &lt;{mainStreamer.guild.name}&gt;
                </Link>
              </>
            )}
          </span>
        }
        live={props.isSmallScreen ? false : true}
      />

      <div className="rio-takeover-hidden rio-hidden--small rio-hidden--medium streamer-threeway-offset slds-col slds-grow-none">
        {secondaryStreamers.map((streamer: any, index: number) => (
          <div
            style={{ marginBottom: index === 0 ? 8 : 0 }}
            key={`${streamer.stream.name}_${mainStreamer.stream.name}`}
          >
            {
              /* ensure vertical offset matches featured stream*/ isMainShowingTitle && (
                <div className="slds-m-bottom--x-small">&nbsp;</div>
              )
            }
            <StatelessInteractiveStreamPreview
              type="twitch"
              thumbnailUrl={streamer.stream.thumbnail_url}
              width={X_SMALL_SIZE.width}
              height={X_SMALL_SIZE.height}
              thumbnailWidth={X_SMALL_SIZE.width}
              thumbnailHeight={X_SMALL_SIZE.height}
              viewerCount={streamer.stream.viewer_count}
              streamIdentifier={streamer.stream.name}
              isFeatured={streamer.stream.is_featured_stream}
              featuredTitle={streamer.stream.title}
              live={false}
              onClick={() => {
                setActiveStream(props.streamers.indexOf(streamer));
              }}
              streamerTitle={
                <span>
                  <TrackedLink
                    href={`https://twitch.tv/${streamer.stream.name}`}
                    className="rio-realm-link"
                    target="_blank"
                    as="twitch:preview"
                  >
                    {streamer.stream.name}
                  </TrackedLink>
                  {streamer.guild && (
                    <>
                      {' '}
                      of{' '}
                      <Link className="rio-realm-link" to={streamer.guild.path}>
                        &lt;{streamer.guild.name}&gt;
                      </Link>
                    </>
                  )}
                </span>
              }
            />
          </div>
        ))}
        <div className="slds-m-top--x-small">&nbsp;</div>
      </div>

      <div className="rio-hidden--small streamer-threeway-offset slds-col slds-shrink-none">
        {
          /* ensure vertical offset matches featured stream*/ isMainShowingTitle && (
            <div className="slds-m-bottom--x-small">&nbsp;</div>
          )
        }
        <div className="slds-align--absolute-center">
          <TakeoverStatus
            when="inactive"
            fallback={
              // takeover is active, so show a smaller video player
              <VideoDockedComponent
                id="rio-docked-video"
                inStreamPlacement={true}
                slot="stream"
                width={LARGE_SIZE.width}
                height={LARGE_SIZE.height}
                trackVisibility={true}
              />
            }
          >
            {
              // takeover is not active, so show a larger video player
            }
            <VideoDockedComponent
              id="rio-docked-video"
              inStreamPlacement={true}
              slot="stream"
              width={X_LARGE_SIZE.width}
              height={X_LARGE_SIZE.height}
              trackVisibility={true}
            />
          </TakeoverStatus>
        </div>
        <div className="slds-m-top--x-small">&nbsp;</div>
      </div>
    </div>
  );
}

const MultiStreamerLayout = withSiteMeta((props: any) => {
  if (isTierMn1RWFActive(props)) {
    return <TierMn1WorldFirst {...props} />;
  }

  if (isArkheronMastheadActive(props)) {
    return <ArkheronMastheadFeature {...props} />;
  }

  if (isAwcTWWBracketActive(props)) {
    return <AWCTWWBlizzardFeature {...props} />;
  }

  if (isMDIBracketActive(props)) {
    return <MDIBlizzardFeature {...props} />;
  }

  const secondaryStreamers = [...props.streamers];

  const [activeStream, setActiveStream] = useState(0);

  const [makeLiveImmediately, setMakeLiveImmediately] = useState(false);

  const [mainStreamer] = secondaryStreamers.splice(activeStream, 1);

  let arrangement = [];

  if (!props.currentFeatures.no_ads && props.currentFeatures.ac_docking && props.streamers.length >= 3) {
    return (
      <>
        <Media at="sm">
          <DockedStreamView {...props} isSmallScreen={true} />
        </Media>
        <Media greaterThan="sm">
          <DockedStreamView {...props} isSmallScreen={false} />
        </Media>
      </>
    );
  }

  if (props.streamers.length >= 3) {
    arrangement = [
      {
        live: false,
        ...secondaryStreamers[0],
        size: SMALL_SIZE,
        className:
          'rio-takeover-hidden rio-hidden--small rio-hidden--medium streamer-threeway-offset slds-col slds-grow-none',
        onClick: () => {
          setActiveStream(1);
          setMakeLiveImmediately(true);
        }
      },
      {
        live: true,
        ...mainStreamer,
        size: LARGE_SIZE,
        className: 'rio-hidden--small slds-m-horizontal--xx-small slds-col slds-grow-none',
        onClick: () => setMakeLiveImmediately(true)
      },
      {
        live: false,
        ...secondaryStreamers[1],
        size: SMALL_SIZE,
        className:
          'rio-takeover-hidden rio-hidden--small rio-hidden--medium streamer-threeway-offset slds-col slds-grow-none',
        onClick: () => {
          setActiveStream(2);
          setMakeLiveImmediately(true);
        }
      }
    ];
  } else if (props.streamers.length >= 2) {
    arrangement = [
      {
        live: true,
        ...props.streamers[0],
        size: LARGE_SIZE,
        className: 'rio-hidden--small slds-m-right--small slds-size--1-of-2'
      },
      {
        live: false,
        ...props.streamers[1],
        size: LARGE_SIZE,
        className: 'rio-takeover-hidden rio-hidden--small rio-hidden--medium slds-size--1-of-2'
      }
    ];
  } else {
    arrangement = [
      { live: true, ...props.streamers[0], size: LARGE_SIZE, className: 'rio-takeover-hidden rio-hidden--small' }
    ];
  }

  return (
    <div
      className={cx('rio-fuzzy-border rio-fuzzy-border--large', props.className)}
      style={{
        backgroundImage: `url(${asset(
          `/images/dungeons/expansion${Expansions.Current}/all-dungeons-patch-${Patches.Current}.jpg`,
          {
            width: 600,
            quality: 90
          }
        )})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div
        className={cx(
          `${props.className} slds-p-around--medium slds-text-align--center ${
            arrangement.length > 1 ? 'slds-grid slds-grid--vertical-align-center slds-align--absolute-center' : ''
          }`
        )}
      >
        {arrangement.map((info: any) => {
          const getComponent = (overrideLive?: boolean) => {
            return (
              <StatelessInteractiveStreamPreview
                type="twitch"
                thumbnailUrl={info.stream.thumbnail_url}
                width={info.size.width}
                height={info.size.height}
                thumbnailWidth={info.size.width}
                thumbnailHeight={info.size.height}
                viewerCount={info.stream.viewer_count}
                streamIdentifier={info.stream.name}
                isFeatured={info.stream.is_featured_stream}
                featuredTitle={info.stream.title}
                streamerTitle={
                  <span>
                    <TrackedLink
                      href={`https://twitch.tv/${info.stream.name}`}
                      className="rio-realm-link"
                      target="_blank"
                      as="twitch:preview"
                    >
                      {info.stream.name}
                    </TrackedLink>
                    {info.guild && (
                      <>
                        {' '}
                        of{' '}
                        <Link className="rio-realm-link" to={info.guild.path}>
                          &lt;{info.guild.name}&gt;
                        </Link>
                      </>
                    )}
                  </span>
                }
                live={overrideLive ?? info.live}
                makeLiveImmediately={makeLiveImmediately}
                onClick={info.onClick}
                className={cx('stream--larger', info.className)}
              />
            );
          };

          return (
            <Fragment key={info.stream.name}>
              <Media at="sm">{getComponent(false)}</Media>
              <Media greaterThan="sm">{getComponent()}</Media>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
});

export default MultiStreamerLayout;
